module.exports = {
	"articleTitle1": "Best Happy Hour: Good Time Charley's ",
	"catImage": "yellowstar.png",
	"totalCats": 1,
	"name": "Good Time Charley's",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/section/arts/real-world-casting-call",
	"articleSnippet1": "Mar 30, 2017 ... Good Time Charley's happy hour was great to begin with. Monday through Friday\n, 2:30 to 6:00, you can get a pitcher of beer and a plate of ...",
	"articleSnippet2": "Mar 15, 2016 ... “Real World,” MTV's longest-running reality program, will be holding a casting \ncall at Good Time Charley's on South University Avenue from 10 ...",
	"foodRecommendations": [
		{
			"text": "The fishbowls are classic here.",
			"person": "Erik Forkin"
		}
	],
	"articleTitle2": "'Real World' to hold casting call at Good Time Charley's ",
	"address": "1140 S University Ave, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/170406/smk.BOAA_.CharleysRicksPizzaHouseSadako.4.6.17198.jpg?itok=hC9Mu_kP",
			"author": "Sindu Kilaru",
			"caption": ""
		}
	],
	"position": {
		"lat": 42.2748,
		"lng": -83.734831
	},
	"totalMisc": 1,
	"categories": {
		"nightlife": 1,
		"bestofaa": 1,
		"location": 1,
		"entertainment": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/charleys.json
// module id = 846
// module chunks = 0